/** math01.svg … math19.svg under the value-prop marketing folder. */
export const VALUE_PROP_MATH_COUNT = 19;

export const VALUE_PROP_MATH_SRCS: readonly string[] = Array.from(
  { length: VALUE_PROP_MATH_COUNT },
  (_, index) => `/images/marketing/home/value/maths/math${String(index + 1).padStart(2, "0")}.svg`
);

/** Max simultaneous floating glyphs. */
export const VALUE_PROP_MATH_MAX_CONCURRENT = 14;
/** Spawn cadence range while PlayMath is selected. */
export const VALUE_PROP_MATH_SPAWN_MIN_MS = 120;
export const VALUE_PROP_MATH_SPAWN_MAX_MS = 380;
/** Travel duration range (radiate + fade). */
export const VALUE_PROP_MATH_DURATION_MIN_MS = 2200;
export const VALUE_PROP_MATH_DURATION_MAX_MS = 4000;
/** Travel distance range from the Rive center. */
export const VALUE_PROP_MATH_DISTANCE_MIN_PX = 170;
export const VALUE_PROP_MATH_DISTANCE_MAX_PX = 360;
/**
 * Uniform scale applied to every glyph’s intrinsic SVG size so designed
 * relative proportions (small vs large symbols) stay intact.
 */
export const VALUE_PROP_MATH_UNIFORM_SCALE = 0.72;
/** Fraction of each particle’s travel vector where it first appears (0 = center). */
export const VALUE_PROP_MATH_SPAWN_RADIUS_FRACTION = 0.5;

export type ValuePropMathParticle = {
  id: number;
  src: string;
  dx: number;
  dy: number;
  durationMs: number;
};

export function randBetween(min: number, max: number): number {
  return min + Math.random() * (max - min);
}

export function randIntBetween(min: number, max: number): number {
  return Math.floor(randBetween(min, max + 1));
}

/** Pure helper — builds one outward-flying math glyph with randomized motion. */
export function createValuePropMathParticle(
  id: number,
  random: () => number = Math.random
): ValuePropMathParticle {
  const src = VALUE_PROP_MATH_SRCS[Math.floor(random() * VALUE_PROP_MATH_SRCS.length)]!;
  const angle = random() * Math.PI * 2;
  const distance =
    VALUE_PROP_MATH_DISTANCE_MIN_PX +
    random() * (VALUE_PROP_MATH_DISTANCE_MAX_PX - VALUE_PROP_MATH_DISTANCE_MIN_PX);
  const durationMs = Math.round(
    VALUE_PROP_MATH_DURATION_MIN_MS +
      random() * (VALUE_PROP_MATH_DURATION_MAX_MS - VALUE_PROP_MATH_DURATION_MIN_MS)
  );

  return {
    id,
    src,
    dx: Math.cos(angle) * distance,
    dy: Math.sin(angle) * distance,
    durationMs,
  };
}
